// extracted by mini-css-extract-plugin
export default {"ItemTitle":"CommitteeMemberCard_ItemTitle__0Wng5"};